import React from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import {
  AbstractProgramsFilterType,
  defaultAbstractProgramsFilter,
} from '../abstract-programs-filter.type';

interface AbstractProgramsFilterProps {
  filters: AbstractProgramsFilterType;
  loading?: boolean;
  onChange: (filters: AbstractProgramsFilterType) => void;
  onSearch: () => void;
  onClear?: () => void;
}

export const AbstractProgramsFilter: React.FC<AbstractProgramsFilterProps> = ({
  filters,
  loading,
  onChange,
  onSearch,
  onClear,
}) => {
  const update = <K extends keyof AbstractProgramsFilterType>(
    key: K,
    value: AbstractProgramsFilterType[K],
  ) => {
    onChange({ ...filters, [key]: value });
  };

  const handleClear = () => {
    if (onClear) {
      onClear();
      return;
    }
    onChange(defaultAbstractProgramsFilter());
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && !loading) {
      onSearch();
    }
  };

  const styles = {
    container: {
      background: 'white',
      borderRadius: '8px',
      padding: '16px',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.08)',
      display: 'flex',
      flexDirection: 'column' as const,
      gap: '12px',
    },
    title: {
      fontSize: '1.1rem',
      fontWeight: 600 as const,
      color: '#333',
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
      gap: '12px',
    },
    field: {
      display: 'flex',
      flexDirection: 'column' as const,
      gap: '4px',
    },
    label: {
      fontSize: '0.8rem',
      color: '#555',
    },
    footer: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      flexWrap: 'wrap' as const,
      gap: '12px',
      borderTop: '1px solid #eee',
      paddingTop: '12px',
    },
    buttonsRow: {
      display: 'flex',
      gap: '8px',
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.title}>סינונים</div>

      <div style={styles.grid}>
        <div style={styles.field}>
          <label style={styles.label}>שם תוכנית</label>
          <InputText
            value={filters.abstractProgramName ?? ''}
            onChange={(e) =>
              update('abstractProgramName', e.target.value || null)
            }
            onKeyDown={handleKeyDown}
            placeholder="לפחות 2 תווים"
            style={{ width: '100%', direction: 'rtl' }}
          />
        </div>
      </div>

      <div style={styles.footer}>
        <div style={styles.buttonsRow}>
          <Button
            icon="pi pi-filter-slash"
            label="נקה"
            text
            severity="secondary"
            onClick={handleClear}
            disabled={loading}
          />
          <Button
            icon="pi pi-search"
            label="חפש"
            onClick={onSearch}
            loading={loading}
          />
        </div>
      </div>
    </div>
  );
};
